import { ExpertAnketaGeneralEvaluation } from './ExpertAnketaGeneralEvaluation';

export default ExpertAnketaGeneralEvaluation;